import React from 'react';
import { useAppStore } from '../../../store/useAppStore';
import { Icon } from '../../../components/common/Icon';
import { formatScheduleTimeForDisplay } from '../../scheduler/time-format';
import { getLocalDateKey } from '../logic/date-keys';

export const DailyScheduleWidget: React.FC = () => {
    const events = useAppStore(state => state.rehearsalSchedule || []);

    // Get today's events
    const today = getLocalDateKey();
    const todaysEvents = events
        .filter(event => event.date === today)
        .toSorted((a, b) => a.startTime.localeCompare(b.startTime));

    return (
        <div className="bg-white dark:bg-surface-dark rounded-xl border border-gray-200 dark:border-border-dark p-6" data-testid="daily-schedule-widget">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 flex items-center gap-2">
                <Icon name="calendar_today" className="text-primary" />
                Today&apos;s Schedule
            </h3>
            
            {todaysEvents.length === 0 ? (
                <div className="text-center py-8">
                    <Icon name="event_busy" size="xl" className="text-gray-300 dark:text-gray-600 mb-2" />
                    <p className="text-gray-500 dark:text-gray-400">No events scheduled for today</p>
                </div>
            ) : (
                <div className="space-y-2">
                    {todaysEvents.map(event => (
                        <div 
                            key={event.id}
                            className="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg"
                        >
                            <div className="text-sm font-medium text-gray-600 dark:text-gray-400 min-w-[80px]">
                                {formatScheduleTimeForDisplay(event.startTime)}
                            </div>
                            <div className="flex-1">
                                <div className="font-medium text-gray-900 dark:text-gray-100">
                                    {event.title}
                                </div>
                                {event.location ? <div className="text-sm text-gray-600 dark:text-gray-400">
                                        {event.location}
                                    </div> : null}
                            </div>
                            <span className={`px-2 py-1 text-xs font-medium rounded ${
                                event.type === 'performance' ? 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300' :
                                event.type === 'tech' ? 'bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-300' :
                                event.type === 'meeting' ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300' :
                                'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300'
                            }`}>
                                {event.type}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
